import { CompanyExcel } from "../../entities/CompanyExcel"
import { CompanyExcelRepository } from "../../repositories/CompanyExcelRepository"

interface Props {
	CompanyExcelRepository: CompanyExcelRepository
}

export class GetCompanyExcelsUseCase {
	private _companyExcelRepository: CompanyExcelRepository

	constructor({ CompanyExcelRepository }: Props) {
		this._companyExcelRepository = CompanyExcelRepository
	}

	async exec(): Promise<CompanyExcel[]> {
		return await this._companyExcelRepository.getCompanyExcels()
	}
}
